<template>
  <el-dialog
    :visible="!!editingProject"
    title="编辑数据"
    width="1000px"
    @close="closeDialog"
  >
    <el-form :model="detail" ref="form" label-width="130px">
      <el-form-item label="币种：" prop="coinType">
        {{ detail.coinType }}
      </el-form-item>
      <el-form-item label="用户ID：" prop="userId">
        {{ detail.userId }}
        <!-- <el-input v-model="detail.userId"></el-input> -->
      </el-form-item>
      <el-form-item label="分红数量：" prop="amount">
        <el-input v-model="detail.amount"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';

export default {
  name: 'userdividend',
  data() {
    return {
      detail: {}
    };
  },
  computed: {
    ...mapState('userdividend', [
      'coinTypeList',
      'editingProject',
      'languageList'
    ])
  },
  watch: {
    editingProject(val) {
      this.detail = { ...val };
    }
  },
  components: {
    Upload
  },
  methods: {
    ...mapMutations('userdividend', ['setEditingProject']),
    ...mapActions('userdividend', ['update']),
    closeDialog() {
      this.setEditingProject(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.update(this.detail).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>
